import React = require('react');
import { getPromotionPeriod } from './promotions';
import { Button } from 'react-bootstrap';

interface IHomeInsuranceBannerData {
  title: string;
  body: React.ReactNode;
}

export const AdmiralHomeInsuranceBanner = () => {

  const image = require('../../images/bannerImages/offer_household.png')

  const getPromotionPeriodData = (): IHomeInsuranceBannerData => {
    const { isActive } = getPromotionPeriod(new Date(2026, 7, 31));

    if (isActive) {
      return {
        title: 'Your chance to win',
        body: (
          <div className={'ahib--footer'}>
            <div>Already got travel cover with us? Insure your home too for a chance to win a £500 gift card.</div>
            <div>
              <a style={{ textDecoration: 'underline' }}
                 href="https://www.admiral.com/home-competition/terms-and-conditions"
                 target="_blank">T&Cs apply</a>, ends 31 August 2026
            </div>
          </div>
        )
      };
    }

    return {
      title: 'Our home insurance is trusted by millions',
      body: (
        <div className={'ahib--footer'}>
          <div>We protect over 2 million homes across the UK. So you know you can trust us to take care of your happy
            place.
          </div>
          <div style={{ fontSize: '11px' }}> 2,193,954 active policies sold as of 10/03/26.</div>
        </div>
      )
    };
  }

  const redirectOnClick = () => {
    window.open('https://www.admiral.com/home-insurance?media=TRAVL', '_blank');
  }

  const homeInsuranceBannerData = getPromotionPeriodData();

  return (
    <div className={'ahib--container'}>

      <div className={'ahib--overlay-container'}>

        <div className={'ahib-image-container'}>
          <img src={image} alt=""/>
        </div>

        <div className={'ahib-content-container'}>
          <div style={{ fontSize: '22px', marginBottom: '10px' }}>
            {homeInsuranceBannerData.title}
          </div>
          <div style={{ fontSize: '16px' }}>
            {homeInsuranceBannerData.body}
          </div>
          <div style={{ marginTop: '15px' }}>
            <Button className={'admiral-secondary-btn'} style={{ width: '100%' }}
                    onClick={redirectOnClick}>{'START A QUOTE'}</Button>
          </div>
        </div>

        <div className={'ahib-image-container-mobile'}>
          <img src={image} alt=""/>
        </div>
      </div>
    </div>
  );
};
